import React, { useState } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { MinistryFocusSection } from './components/MinistryFocusSection';
import { SermonsSection } from './components/SermonsSection';
import { EventsSection } from './components/EventsSection';
import { BooksSection } from './components/BooksSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GallerySection } from './components/GallerySection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { BookPage } from './pages/BookPage';
export function App() {
  const [currentPage, setCurrentPage] = useState<'home' | 'book'>('home');
  if (currentPage === 'book') {
    return <BookPage onBack={() => {
      setCurrentPage('home');
      window.scrollTo(0, 0);
    }} data-id="element-0" />;
  }
  return <div className="min-h-screen bg-cream text-charcoal font-inter selection:bg-gold selection:text-white" data-id="element-1">
      <Navbar onNavigateToStore={() => {
      setCurrentPage('book');
      window.scrollTo(0, 0);
    }} data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <AboutSection data-id="element-5" />
        <MinistryFocusSection data-id="element-6" />
        <SermonsSection data-id="element-7" />
        <EventsSection data-id="element-8" />
        <BooksSection onBuyNow={() => {
        setCurrentPage('book');
        window.scrollTo(0, 0);
      }} data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
        <GallerySection data-id="element-11" />
        <ContactSection data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}